import { Link, NavLink } from "react-router-dom";
import { Gift, History, Ticket, User } from "lucide-react";

// Add more entries here and every page using <WebHeader /> gets them
export const WEB_NAV_LINKS = [
    { to: "/web/my-vouchers", label: "My Vouchers", icon: Ticket },
    { to: "/web/redeem-history", label: "Redeem History", icon: History },
    { to: "/web/refer-and-earn", label: "Refer & Earn", icon: Gift },
];

const getInitials = (name = "") =>
    name
        .trim()
        .split(" ")
        .filter(Boolean)
        .slice(0, 2)
        .map((n) => n[0]?.toUpperCase())
        .join("");

/**
 * Shared top bar for the /web pages: logo, nav links, customer avatar + name.
 * name      : customer name (omit to show a generic avatar)
 * links     : nav links, default WEB_NAV_LINKS (pass [] to hide)
 * homePath  : where the logo goes
 * children  : extra content on the right, before the profile
 */
export default function WebHeader({ name = "", links = WEB_NAV_LINKS, homePath = "/web/home", showProfile = true, children }) {
    const initials = getInitials(name);

    return (
        <header className="sticky top-0 z-30 border-b border-gray-100 bg-white/90 shadow-sm backdrop-blur">
            <div className="mx-auto flex max-w-6xl items-center justify-between gap-3 px-4 py-3 sm:px-6">
                <div className="flex items-center gap-4 sm:gap-8">
                    <Link to={homePath} className="shrink-0">
                        <img src="/goerone_logo.png" alt="GoerOne" className="h-10" />
                    </Link>

                    {links.length > 0 && (
                        <nav className="flex items-center gap-1">
                            {links.map(({ to, label, icon: Icon }) => (
                                <NavLink
                                    key={to}
                                    to={to}
                                    className={({ isActive }) =>
                                        `flex items-center gap-1.5 rounded-full px-3 py-1.5 text-sm font-semibold transition-colors ${
                                            isActive ? "bg-[#0B67FC] text-white shadow-sm" : "text-gray-600 hover:bg-[#0B67FC]/10 hover:text-[#0B67FC]"
                                        }`
                                    }
                                >
                                    {Icon && <Icon size={16} />}
                                    {label}
                                </NavLink>
                            ))}
                        </nav>
                    )}
                </div>

                <div className="flex items-center gap-3">
                    {children}
                    {showProfile && (
                        <div className="flex items-center gap-3">
                            <div className="flex h-9 w-9 items-center justify-center rounded-full bg-[#0B67FC] text-sm font-semibold text-white">
                                {initials || <User size={16} />}
                            </div>
                            {name && <span className="hidden text-sm font-medium text-gray-700 sm:block">{name}</span>}
                        </div>
                    )}
                </div>
            </div>
        </header>
    );
}